import { useFlag } from 'lane-shared/hooks';

import { FeatureFlag } from 'constants-flags';

export function useInspectionsAddFromPhotoGalleryEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.InspectionsAddFromPhotoGallery,
    false
  );

  return Boolean(isEnabled);
}
